/**
 * Component Accordion
 * 
 * @module component-accordion
 * @version 1.0.0
 * @extends HTMLElement
 */

const componentName = 'component-accordion';

if (!customElements.get(componentName)) {
    
    class ComponentAccordion extends HTMLElement {

        constructor() {
            super();

            this.trigger = this.querySelector('[data-accordion-trigger]');
            this.container = this.querySelector('[data-accordion-container]');
            this.isOpen = false;

            this.initEvents();
            this.observeContainerHeight();
        }

        initEvents() {
            if (!this.container || !this.trigger) return;

            this.loadAttributes();

            this.trigger.addEventListener('click', (event) => {
                event.preventDefault();

                this.toggle().then(() => {
                    this.applyMaxHeightOnParent();
                });
            });
        }

        applyMaxHeightOnParent() {
            this.container.style.maxHeight = this.isOpen ? `${this.container.scrollHeight}px` : "0px";
        }

        observeContainerHeight() {
            const resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    if (this.isOpen) {
                        this.container.style.maxHeight = `${entry.target.scrollHeight}px`;
                    }
                }
            });
        
            resizeObserver.observe(this.container);
        
            const mutationObserver = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    if (mutation.type === "childList" || mutation.type === "subtree") {
                        if (this.isOpen) {
                            this.container.style.maxHeight = `${this.container.scrollHeight}px`;
                        }
                    }
                });
            });
        
            mutationObserver.observe(this.container, { childList: true, subtree: true });
        }
        
        

        loadAttributes() {
            this.close();

            let id = Math.floor(Math.random() * 10000);
            this.trigger.setAttribute('aria-controls', `accordion__container_${id}`);
            this.trigger.id = `accordion__trigger__${id}`;

            this.container.setAttribute('role', 'region');
            this.container.setAttribute('aria-labelledby', `accordion__trigger__${id}`);
            this.container.id = `accordion__container__${id}`;

            if (this.hasAttribute('data-overview-accordion') || this.hasAttribute('data-initial-open')) {
                if(this.hasAttribute('data-desktop-only') && window.innerWidth < 1024) {
                    return;
                }
                this.toggle().then(() => {
                    this.applyMaxHeightOnParent();
                });
            }
        }

        toggle() {
            return new Promise((resolve, reject) => {
                if (this.container) {
                    if (this.isOpen) {
                        this.close();
                    } else {
                        this.open();
                    }
                    resolve(this.container.scrollHeight);
                }
            });
        }
        

        close() {
            if (this.resizeObserver) this.resizeObserver.disconnect();

            this.trigger.classList.remove('active');
            this.container.classList.remove('active');
            this.container.setAttribute('aria-expanded', 'false');
            this.isOpen = false;

            setTimeout(() => {
                if (!this.isOpen) {
                  this.container.classList.add('hidden');
                  this.container.style.display = 'none';
                }
            }, 500);
        }

        open() {
            this.trigger.classList.add('active');
            this.container.classList.add('active');
            this.container.classList.remove('hidden');
            this.container.setAttribute('aria-expanded', 'true');
            this.isOpen = true;

            this.container.style.maxHeight = `${this.container.scrollHeight}px`;
            this.container.style.removeProperty('display');
        }
    }

    customElements.define(componentName, ComponentAccordion);
}
